import { KONKURSY,OPCJE, PYTANIA, UCZESTNIK } from "./typyDanych";
import {ADD,KASOWANIE,MODYFIKACJA} from './typyAkcji'


export const zapisKonkurs = (konkurs) => {
    return kreacjaZapisKonkurs(KONKURSY,konkurs)
}

export const delKonkurs = (konkurs) => {
    return reset(KONKURSY,konkurs)
}

export const modOpcje = (opcja) => {
    return modyfikacja(OPCJE,opcja)
}
export const zapisListaPytan = (pytanie) => {
    return kreacjaZapisKonkurs(PYTANIA,pytanie)
}
export const delListaPytan = (konkurs) => {
    return reset(PYTANIA,konkurs)
}
export const zapisLogin = (user) => {
    return modyfikacja(UCZESTNIK,user)
}
export const delLogin = (user) => {
    return reset(UCZESTNIK,user)
}

const kreacjaZapisKonkurs = (typDanych,dane) => {
        return {
            type: ADD,
            dataType: typDanych,
            dane: dane
        }
    }
const reset = (typDanych,dane) => {
    return {
        type: KASOWANIE,
        dataType: typDanych,
        dane: dane
    }
}
const modyfikacja = (typDanych,dane) => {
        return {
            type: MODYFIKACJA,
            dataType: typDanych,
            dane: dane
        }
    }
